module.exports = __webpack_public_path__ + "static/media/1021524.72a9a059.jpg";